export const listChipStyle = theme => ({
    chipsDetails: {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paddingDetails: {
        paddingTop: theme.spacing(1),
        whiteSpace: 'initial',
    },
    subtitle2: {
        whiteSpace: 'initial',
        fontWeight: 500,
        display: 'block',
        float: 'left',
        width: '75px',
        textAlign: 'right',
        marginRight: '5px'
    }
})